import ServerPackage from "@/Packages/Servers/package.js";
import StationPackage from "@/Packages/Stations/package.js";
import UserPackage from "@/Packages/Users/package.js";
import RecordingPackage from "@/Packages/Recordings/package.js";
import JobPackage from "@/Packages/Jobs/package.js";
import ClipProfilePackage from "@/Packages/ClipProfiles/package";
import ClipPackage from "@/Packages/Clips/package";

export const Packages = {
  ServerPackage,
  StationPackage,
  UserPackage,
  RecordingPackage,
  JobPackage,
  ClipProfilePackage,
  ClipPackage
};
